import { Helper } from '../Helper';
export class CloneArrayHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'UNPACK');
        sb.emitOp(node, 'PACK');
    }
}

//# sourceMappingURL=CloneArrayHelper.js.map
